<!-------------Earn Wellbux Fold Start----------------->
<div class="earn__wellbux__fold " data-aos="fade-up" id="earn__wellbux">
    <div class="container">
      <h1>Earn Wellbux</h1>
      <strong>Whether you are a corporate user or a wellbux user, you just need to participate in challenges to earn wellbux.</strong>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-3" data-aos="fade-up">
          <div class="earn__wellbux__fold__box">
            <h2>Sign Up</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3" data-aos="fade-up">
          <div class="earn__wellbux__fold__box">
            <h2>Earn Points</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3" data-aos="fade-up">
          <div class="earn__wellbux__fold__box">
            <h2>Buy Coupons</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3" data-aos="fade-up">
          <div class="earn__wellbux__fold__box">
            <h2>Reedem Coupons</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------------Earn Wellbux Fold End----------------->